export default {
  title: "Actualización de Token",
  subtitle: "Sigue los pasos para poder actualizar todos tus tokens y posiciones",
  connect: "Conecta tu billetera",
  disconnect: "Desconectar",
  switch_network: "Cambia de red",
  info: "Debes actualizar tus antiguos tokens CNKT para conseguir el nuevo token CNKT+, con mayor utilidad y servicios añadidos. Haz click en los botones de abajo para proceder a la actualización. Replicaremos, exactamente igual, la posición que tenías en el antiguo CNKT pero con el nuevo CNKT+.",
  steps: {
    withdraw:
      "Retira tu posición de los distintos pools para obtener tus tokens y LP haciendo click en el botón de retirar de cada una de tus posiciones.",
    approve: "Autoriza los tokens para, después, poderlos actualizar.",
    migrate:
      "Confirma la actualización. Aquí podrás ver el resumen de todo lo que vas a actualizar así como el reparto de airdrops en función de tus posiciones. Ten en cuenta que los valores son aproximados (por el slippage).",
  },
  yields: {
    name: "Nombre",
    deposited: "Depositado",
    rewards: "Recompensas",
    actions: "Acciones",
    withdraw: "Retirar",
    migrate: "Actualizar",
  },
  approve: "Autorizar",
  loading: "Cargando...",
  completed: {
    title: "No tienes tokens a actualizar",
    info: "Actualizaste todo correctamente, o sencillamente en esta billetera no tienes tokens a actualizar.",
    explorer: "Ver transacción en el Explorador:",
    cta: "Ir a la DAPP",
  },
  error: {
    title: "Error al cargar la información de actualización",
    message: "Hubo un error al cargar tus datos de actualización. Por favor, inténtalo de nuevo más tarde.",
    retry: "Reintentar",
  },
}
